import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Switch,
  Select,
  Grid,
  GridItem,
  Button,
  Spacer,
  Tooltip,
  Badge,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Icon,
  Flex,
} from "@chakra-ui/react";
import moment from "moment";
import { LockIcon, UnlockIcon } from "@chakra-ui/icons";
const LockRenderer = ({ value }) => {
  return value ? (
    <LockIcon color={"red.400"} />
  ) : (
    <UnlockIcon color={"green.400"} />
  );
};

LockRenderer.propTypes = {
  value: PropTypes.string,
};

export default LockRenderer;
